/**
 * Format a timestamp string into a human-readable relative time format
 * @param dateString - ISO timestamp string (with or without timezone)
 * @param showDays - Whether to show "Xd ago" format for days (default: false, shows date instead)
 * @returns Formatted time string like "Just now", "5m ago", "2h ago", "3d ago" or date
 */
export function formatRelativeTime(dateString: string, showDays = false): string {
  // Ensure the dateString is treated as UTC by appending 'Z' if not present
  const utcDateString = dateString.endsWith('Z') ? dateString : dateString + 'Z'
  const date = new Date(utcDateString)
  const now = new Date()
  const diffInMs = now.getTime() - date.getTime()
  const diffInMinutes = Math.floor(diffInMs / (1000 * 60))
  const diffInHours = Math.floor(diffInMs / (1000 * 60 * 60))
  const diffInDays = Math.floor(diffInMs / (1000 * 60 * 60 * 24))

  if (diffInMinutes < 1) {
    return 'Just now'
  } else if (diffInMinutes < 60) {
    return `${diffInMinutes}m ago`
  } else if (diffInHours < 24) {
    return `${diffInHours}h ago`
  } else if (showDays && diffInDays < 7) {
    return `${diffInDays}d ago`
  } else {
    return date.toLocaleDateString()
  }
}
